import { Event } from 'services/api';
import { CheckInResult } from 'services/api/apis/receipts/receipts.api';

export type CheckInMode = 'attendee' | 'organizer';

export type AttendeeTab = 'myCode' | 'scan';
export type OrganizerTab = 'scan' | 'email' | 'eventCode';

export type ResultKind =
  | 'checked_in'
  | 'already_checked_in'
  | 'invalid'
  | 'closed'
  | 'not_open'
  | 'rsvp_required'
  | 'outside_guest'
  | 'see_organizer'
  | 'self_blocked'
  | 'unverified'
  | 'cancelled'
  | 'rate_limited';

export const toResultKind = (status?: string): ResultKind => {
  switch (status) {
    case 'checked_in':
      return 'checked_in';
    case 'already_used':
    case 'already_checked_in':
      return 'already_checked_in';
    case 'not_started':
    case 'not_open':
      return 'not_open';
    case 'closed':
      return 'closed';
    case 'rsvp_required':
    case 'disabled':
      return 'rsvp_required';
    case 'outside_guest':
      return 'outside_guest';
    case 'see_organizer':
      return 'see_organizer';
    case 'self_blocked':
      return 'self_blocked';
    case 'unverified':
      return 'unverified';
    case 'cancelled':
      return 'cancelled';
    case 'rate_limited':
      return 'rate_limited';
    default:
      return 'invalid';
  }
};

export interface TicketHolder {
  firstName: string;
  lastName: string;
  email: string;
  ticketNumber?: string;
  ticketType?: string;
  typeId?: string;
  checkedInDate?: string;
}

export interface EventCheckInSheetProps {
  open: boolean;
  onClose: () => void;
  event: Event;
  receiptId?: string;
  tickets?: TicketHolder[];
  /** Force organizer mode (e.g. admin check-in route) */
  forceOrganizer?: boolean;
}

export interface ScanResultState {
  kind: ResultKind;
  checkedInAt?: string;
  opensAt?: string;
  ticket?: CheckInResult['ticket'];
}
